import { CompanySimpleResponseDTO } from '../types';

export class CompanyDataTransformer {
  static sortCompanies(companies: CompanySimpleResponseDTO[]): CompanySimpleResponseDTO[] {
    // 대표 회사를 먼저 정렬
    return [...companies].sort((a, b) => Number(b.isPrimary) - Number(a.isPrimary));
  }

  static filterCompanies(
    companies: CompanySimpleResponseDTO[], 
    searchTerm: string
  ): CompanySimpleResponseDTO[] {
    if (!searchTerm.trim()) return companies;
    
    return companies.filter(company =>
      company.bizKorNm.toLowerCase().includes(searchTerm.toLowerCase()) || 
      company.bizNo.includes(searchTerm) ||
      company.corpNo.includes(searchTerm) ||
      company.bizCeoKorNm.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }

  static getCompanyTypeDisplay(type: 'INDIVIDUAL' | 'CORPORATION'): string {
    return type === 'INDIVIDUAL' ? '개인' : '법인';
  }

  static formatAddress(addr: string, addrDetl: string): string {
    if (!addr && !addrDetl) return '';
    if (!addr) return addrDetl.trim();
    if (!addrDetl) return addr.trim();
    
    // 도로명 주소와 상세 주소가 모두 있으면 콤마로 구분
    return `${addr.trim()}, ${addrDetl.trim()}`;
  }

  static buildAccountingUrl(
    companyId: string, 
    period: string, 
    startDate: string, 
    endDate: string
  ): string {
    const dateRange = startDate.replace(/-/g, '') + endDate.replace(/-/g, '');
    return `http://act.xadom.ai:8001/main?cId=${companyId}&period=${period}&dateRange=${dateRange}`;
  }
} 